<template>
  <!-- :navigate-to="[startingSlide || 0, false]" -->

      <div class="container">
				<!-- Can determine if it is on mobile as well.  -->
        <component :is="link ? 'a' : 'div'" :href="(link!='') ? link : ''">
          <carousel
              :per-page-custom="numPerPage"
              :scrollPerPage="scroll_per_page"
              :loop="true"
              :mouse-drag="false"
              :paginationEnabled="false"
              :navigationEnabled="show_controls !== undefined ? show_controls : true"
              :autoplay="shouldAutoplay"
              :autoplayTimeout="autoplaySeconds"
              :autoplayHoverPause="true"
              @navigation-click="navigationClick"
          >
            <Slide v-for="(slide, index) in slides" :key="index">
                <img :src="slide.image.sizes.medium_large" :height="slide.image.sizes['medium_large-height']" :width="slide.image.sizes['medium_large-width']" />
            </Slide>
          </carousel>
        </component>
      </div>
</template>

<script>
// Documentation https://github.com/SSENSE/vue-carousel
import { Carousel, Slide } from "vue-carousel";

export default {
    name: "Slider",
  components: {
    Carousel,
    Slide
  },
  props: [
    // "startingSlide",
    "autoplay", //number, 0 means no autoplay
    "slides",
    "slides_per_page",
		"slides_per_page_mobile",
    "scroll_per_page", // boolean, scroll per item or per page
    "show_controls", // show or hide slider controls
    "link"
  ],
  data() {
    return {
      interactedWith: false,
      interactionTimeout: null
    };
  },
  mounted(){
    this.$nextTick(() => {
      window.dispatchEvent(new Event('resize')) //makes sure first image shows up in slider
    })
  },
  methods: {
    navigationClick() {
      //called when navigation clicked
      this.interactedWith = true;
      clearTimeout(this.interactionTimeout);
      //re-enable autoplay with delay after last interaction
      this.interactionTimeout = setTimeout(() => {
        this.interactedWith = false;
      }, 5000);
    }
  },
  computed: {
    shouldAutoplay() {
      let defaultAutoplay = this.autoplay === undefined ? true : this.autoplay != 0;
      return defaultAutoplay && !this.interactedWith;
    },
    autoplaySeconds(){
      return this.autoplay *1000
    },
		numPerPage(){
			if(this.slides_per_page_mobile !== undefined){
				return [[320,parseInt(this.slides_per_page_mobile)],[768,parseInt(this.slides_per_page)]]
			} else {
				return [[0, parseInt(this.slides_per_page)]] //width greater than 0 then set to slides per page
			}
		}
  }
};
</script>


<style lang="scss" scoped>

.VueCarousel{
  width: 100%;
  margin: 5px auto;
}

.VueCarousel::v-deep .VueCarousel-slide{
  padding: 0 5px;
}

.VueCarousel-slide{
    text-align: center;
    img{
        max-width:100%;
        height:auto;
    }
}
</style>
